
// Firebase modular SDK initialization and service exports
import * as firebase_app from "firebase/app";
import * as firebase_auth from "firebase/auth";
import * as firebase_functions from "firebase/functions";
import { 
  getFirestore, 
  doc, 
  getDoc, 
  getDocs, 
  collection, 
  deleteDoc, 
  setDoc, 
  onSnapshot, 
  query, 
  where, 
  orderBy, 
  updateDoc, 
  addDoc 
} from "firebase/firestore";

const { initializeApp } = firebase_app as any;
const { 
  getAuth, 
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged, 
  signOut, 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  sendPasswordResetEmail, 
  OAuthProvider, 
  signInWithPopup, 
  updateEmail, 
  updateProfile,
  signInWithCustomToken 
} = firebase_auth as any;

const { getFunctions, httpsCallable } = firebase_functions as any;

const firebaseConfig = {
  apiKey: "AIzaSyAGQqqA0m4kS0J71GuT8-n8FBS721nlxhA",
  authDomain: "makerstory-shopping.firebaseapp.com",
  projectId: "makerstory-shopping",
  storageBucket: "makerstory-shopping.firebasestorage.app",
  messagingSenderId: "815864927164",
  appId: "1:815864927164:web:55a6fbec0df865727b51b9",
};

// Initialize Firebase app and services
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// [핵심 수정] 인증 지속성을 가장 먼저 설정하여 모바일 리다이렉트 후 세션 복구 확률 극대화
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.debug("Firebase persistence set to LOCAL");
  })
  .catch((err: any) => console.error("Persistence error:", err));

const functions = getFunctions(app, "asia-northeast3"); 

export {
  auth,
  db,
  functions,
  httpsCallable,
  onAuthStateChanged,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  OAuthProvider,
  signInWithPopup,
  updateEmail,
  updateProfile,
  signInWithCustomToken,
  doc,
  getDoc,
  getDocs,
  collection,
  deleteDoc,
  setDoc,
  onSnapshot,
  query,
  where,
  orderBy,
  updateDoc,
  addDoc
};
